export default __webpack_public_path__ + "static/media/user-role-type-icon.561b78c8.svg";